import * as React from 'react';
import { Select, Tooltip } from 'antd';
import type { DynamicComponentProps } from '@/types/commontypes';
import styles from '../../../styles/global.module.css';

const { Option } = Select;

const FontSizeSelector: React.FC<DynamicComponentProps<number>> = ({ value, onChange, label }) => {
  // Ensure the value is a number, fallback to a default number (e.g., 8) if not a valid number
  const validValue = typeof value === 'number' ? value : 8;

  // Handle font size change and Pass the selected font size to the parent component
  const handleFontSizeChange = (selectedValue: number) => {
    onChange(selectedValue);
  };

  return (
    <div>
      <Tooltip title={label || 'Font Size'}>
        <Select value={validValue} onChange={handleFontSizeChange} className={`${styles.font_size_select}`}>
          {Array.from({ length: 17 }, (_, index) => 8 + index * 2).map(size => (
            <Option key={size} value={size} className={`${styles.font_size_option}`}>
              {size}px
            </Option>
          ))}
        </Select>
      </Tooltip>
    </div>
  );
};

export default FontSizeSelector;
